import { AutogenLayoutJobClassCodeList } from "./autogen/AutogenLayoutJobClassCodeList";

export class JobClassCodeList extends AutogenLayoutJobClassCodeList {
    onLoad(): void | Promise<void> {
        this.mainDataSource.orderBy = [{ field: "descr", sort: "asc" }];
    }
}
